import { formatBRL } from '@/lib/utils';

interface Props {
  total: number;
  shiftsCount: number;
  itemsCount: number;
  isLoading?: boolean;
}

export function TotalCard({ total, shiftsCount, itemsCount, isLoading }: Props) {
  return (
    <section
      className="rounded-xl border border-(--color-border) bg-(--color-surface) p-5"
      aria-live="polite"
    >
      <p className="text-sm text-(--color-fg-muted)">Total mensal a receber</p>
      <p className="font-display text-3xl font-semibold tabular-nums md:text-4xl">
        {isLoading ? '—' : formatBRL(total)}
      </p>
      <div className="mt-3 flex flex-wrap gap-4 text-sm text-(--color-fg-muted)">
        <span>
          <strong className="text-(--color-fg)">{shiftsCount}</strong> plantões
        </span>
        <span>
          <strong className="text-(--color-fg)">{itemsCount}</strong> procedimentos
        </span>
      </div>
    </section>
  );
}
